import request from '../../utils/request'
import { GETPRODUCTCFGTEMP } from '../constants'

/**
 * 获取产品配置模板
 * @param {*} params
 * @returns
 */
export const getCompTemp = (params) => {
  return async (dispatch) => {
    const res = await request.get('sys/comp/', {
      params,
    })
    dispatch({
      type: GETPRODUCTCFGTEMP,
      payload: res.data.data,
    })
  }
}
/**
 * 校验模板
 */
export const getProTrigger = (params, isLoading) => {
  return async (dispatch) => {
    return await request.get('sys/comp/check/delete/', { params, isLoading })
  }
}
/**
 * 同步模板
 */
export const syncTemp = (values, isLoading) => {
  return async (dispatch) => {
    return await request.put('sys/comp/sync/', values)
  }
}
